export const REGION_MANAGER_LOAD_COUNTRIES_REQUEST = "REGION_MANAGER/LOAD_COUNTRIES_REQUEST";
export const REGION_MANAGER_LOAD_COUNTRIES_SUCCESS = "REGION_MANAGER/LOAD_COUNTRIES_SUCCESS";
export const REGION_MANAGER_LOAD_COUNTRIES_FAILURE = "REGION_MANAGER/LOAD_COUNTRIES_FAILURE";

export const REGION_MANAGER_LOAD_REGIONS_REQUEST = "REGION_MANAGER/LOAD_REGIONS_REQUEST";
export const REGION_MANAGER_LOAD_REGIONS_SUCCESS = "REGION_MANAGER/LOAD_REGIONS_SUCCESS";
export const REGION_MANAGER_LOAD_REGIONS_FAILURE = "REGION_MANAGER/LOAD_REGIONS_FAILURE";

export const REGION_MANAGER_SET_INHERIT = "REGION_MANAGER/SET_INHERIT";
export const REGION_MANAGER_SET_SOURCE_DIVISION = "REGION_MANAGER/SET_SOURCE_DIVISION";

export const REGION_MANAGER_INHERITANCE_LOADED = "REGION_MANAGER/INHERITANCE_LOADED";
export const REGION_MANAGER_INHERITANCE_SAVED = "REGION_MANAGER/INHERITANCE_SAVED";

export const REGION_MANAGER_SET_COUNTRY_REGION = "REGION_MANAGER/SET_COUNTRY_REGION";
export const REGION_MANAGER_SET_BULK_REGION = "REGION_MANAGER/SET_BULK_REGION";
export const REGION_MANAGER_SELECT_COUNTRIES = "REGION_MANAGER/SELECT_COUNTRIES";
export const REGION_MANAGER_SELECT_ALL = "REGION_MANAGER/SELECT_ALL";
export const REGION_MANAGER_UNSELECT_ALL = "REGION_MANAGER/UNSELECT_ALL";

export const REGION_MANAGER_SET_SEARCH = "REGION_MANAGER/SET_SEARCH";
export const REGION_MANAGER_SET_SORT = "REGION_MANAGER/SET_SORT";

export const REGION_MANAGER_SAVE_REQUEST = "REGION_MANAGER/SAVE_REQUEST";
export const REGION_MANAGER_SAVE_SUCCESS = "REGION_MANAGER/SAVE_SUCCESS";
export const REGION_MANAGER_SAVE_FAILURE = "REGION_MANAGER/SAVE_FAILURE";

export const REGION_MANAGER_DISCARD_CHANGES = "REGION_MANAGER/DISCARD_CHANGES";

export const REGION_MANAGER_OPEN_VIEW_REGIONS = "REGION_MANAGER/OPEN_VIEW_REGIONS";
export const REGION_MANAGER_CLOSE_VIEW_REGIONS = "REGION_MANAGER/CLOSE_VIEW_REGIONS";
export const REGION_MANAGER_REGIONS_SAVED = "REGION_MANAGER/REGIONS_SAVED";